/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@farmlands/shadcn-ui";
import { FC, JSX } from "react";

import TestIds from "../../../../../testIds";
import { TruckLoadingLayout } from "../TruckLoadingLayout/TruckLoadingLayout";

export interface IDeleteAccountLoadingProps {
  open: boolean;
}

const DeleteAccountLoading: FC<IDeleteAccountLoadingProps> = ({ open }): JSX.Element => (
  <Dialog open={open}>
    <DialogContent
      showCloseButton={false}
      className="max-w-82!"
      data-testid={TestIds.feat.account.profile.deleteAccountModal.loader}
      onInteractOutside={(e: Event) => e.preventDefault()}
      onEscapeKeyDown={(e: KeyboardEvent) => e.preventDefault()}
    >
      <DialogTitle className="sr-only">Processing your request</DialogTitle>

      <DialogDescription className="sr-only">
        Please wait while we process your request
      </DialogDescription>

      <DialogBody>
        <TruckLoadingLayout
          message={<p className="text-sm font-bold">Creating request to delete account...</p>}
          className="min-h-37.5! p-0!"
        />
      </DialogBody>
    </DialogContent>
  </Dialog>
);

export default DeleteAccountLoading;
